import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/dashboard";

export const DahshboardOverview = async (period) => {
  return await axiosInstance(options).get(`${path}/overview?period=${period}`);
};
export const Counts = async () => {
  return await axiosInstance(options).get(`${path}/counts`);
};

export const DateWiseTransaction = async () => {
  return await axiosInstance(options).get(`${path}/date-wise-transaction`);
};

export const DateWiseBooking = async () => {
  return await axiosInstance(options).get(`${path}/date-wise-booking`);
};

// Revenue Related Services
export const RevenueOverview = async (period) => {
  return await axiosInstance(options).get(
    `${path}/revenue/overview?period=${period}`,
  );
};

export const RevenueDailyTrend = async (period) => {
  return await axiosInstance(options).get(
    `${path}/revenue/daily-trend?period=${period}`,
  );
};
export const RevenueSources = async (period) => {
  return await axiosInstance(options).get(
    `${path}/revenue/sources?period=${period}`,
  );
};

export const getDashboardUsers = async (role, page) => {
  return await axiosInstance(options).get(
    `${path}/users?role=${role}&page=${page}`,
  );
};
// Analytics Related Services
export const getUserGrowth = async () => {
  return await axiosInstance(options).get(`${path}/analytics/user-growth`);
};
export const getTopAstrologers = async () => {
  return await axiosInstance(options).get(`${path}/analytics/top-astrologers`);
};

export const getSidebarBadges = async () => {
  return await axiosInstance(options).get(`${path}/sidebar-badges`);
};
